// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".student-help-button--layout {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 15px;\n  width: 100%;\n  position: relative;\n  padding: 10px 30px;\n  cursor: pointer; }\n  .student-help-button--layout svg {\n    width: 20px; }\n  .student-help-button--layout::after {\n    content: '';\n    position: absolute;\n    bottom: -5px;\n    width: calc(100% - 60px);\n    left: 30px;\n    height: 1px;\n    background-color: white; }\n", ""]);
// Exports
module.exports = exports;
